import React, { useCallback, useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';
import { Typography } from 'web-library';
import { useTranslation } from 'react-i18next/';
import RouteKey from '../../../routes/key';
import { useAuth } from '../logic/auth';
import { CUSTOMIZED_UNAUTHORIZED_STATUS_CODE } from '../../../api/config/misc';
import { useTriggerMutate } from '../../../hooks/query';
import { usePostSingPassToken } from '../../../api-refactored/user/usePostSingPassToken';
import { GET_USER_DETAILS_QUERY_KEY } from '../../../constants/queryKeys';
import { LocationState } from '../../../models/Location';

const { auth: authKey } = RouteKey.child;
const { login } = RouteKey.auth.child;

export default function SingPass() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation<LocationState>();
  const auth = useAuth();
  const queryClient = useQueryClient();

  const urlToBeRedirectedAfterLoggedInData = sessionStorage.getItem(
    'urlToBeRedirectedAfterLoggedIn'
  ) as string;
  const urlToBeRedirectedAfterLoggedInObject = JSON.parse(urlToBeRedirectedAfterLoggedInData);

  const authenticateSingPassUser = usePostSingPassToken({
    onSuccess: (data) => {
      if (data.userExist === false) {
        window.location.href = data.myInfoRedirectUrl;
      } else {
        queryClient.invalidateQueries(GET_USER_DETAILS_QUERY_KEY);
        auth.signin();
        history.replace(
          `${urlToBeRedirectedAfterLoggedInObject.from.pathname}${urlToBeRedirectedAfterLoggedInObject.from.search}`,
          {
            from: { pathname: location.pathname },
          }
        );
        sessionStorage.removeItem('urlToBeRedirectedAfterLoggedIn');
      }
    },
    onError: (err) => {
      switch (err.response?.status) {
        case CUSTOMIZED_UNAUTHORIZED_STATUS_CODE:
          if (
            err.response?.data?.code?.toString() === '1008' ||
            err.response?.data?.code?.toString() === '1009'
          ) {
            history.push(`/${authKey}/${login}`, {
              message: err.response.data.message,
              code: err.response.data.code,
            });
          }
          break;
        case 403:
          history.push('/error/403');
          break;
        case 417:
          if (
            err.response?.data?.code?.toString() === '1201' &&
            err.response?.data?.data!.url !== undefined
          ) {
            window.location.href = err.response?.data?.data.url as string;
          }
          break;
        default:
          // If no response from api call, land in login page
          history.push('/');
          break;
      }
    },
  });

  const url = window.location.search;
  const params = new URLSearchParams(url);
  const code = params.get('code');
  const state = params.get('state');

  const callMutation = useCallback(() => {
    const parameters = {
      code,
      state,
    };

    authenticateSingPassUser.mutate(parameters);
  }, [authenticateSingPassUser, code, state]);
  const setTriggerMutate = useTriggerMutate(callMutation);

  useEffect(() => {
    if (code && state) {
      setTriggerMutate((prev) => prev + 1);
    }
  }, [code, setTriggerMutate, state]);

  return (
    <div>
      <br />
      <Typography variant="h6">
        &nbsp;&nbsp;{t('profile->>SingPassPage.SingPass Login....')}
      </Typography>
    </div>
  );
}
